import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';
import Save from './save';
import deprecated from './deprecated';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  deprecated,
  icon: {
    foreground: '#0061FE',
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        {/* A wave splitting two bands */}
        <path d="M2 4h20v6c-3.5 0-3.5 3-7 3s-3.5-3-7-3-3.5 3-6 3V4z" opacity=".45" />
        <path d="M2 13c2.5 0 2.5-3 6-3s3.5 3 7 3 3.5-3 7-3v10H2v-7z" />
      </svg>
    ),
  },
});
